export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7072f17a0c15e9abbae23944c880fdd0e82f7d744a&name=pushAdClickData!'